import React from 'react';
import {
  Box,
  Container,
  Typography,
  Stack,
  Grid,
  Card,
  CardMedia,
  Paper,
} from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';

import campsAndClinicsHeroImage from '../../../images/lgn-intramural.png';
import sixWeekSeries from '../../../images/camps-and-clinics/six-week-series-flyer.jpg';
import fridayNightLights from '../../../images/camps-and-clinics/friday-night-lights-flyer.jpg';
import fallWinterSkillsClinic from '../../../images/camps-and-clinics/matt-alec-zack-clinic.jpeg';
import veteransDayClinic from '../../../images/camps-and-clinics/veterans-day-flyer.png';

const campsAndClinicsCards = [
    {
    title: 'Veterans Day Clinic',
    href: 'https://atlanticunitedsc.byga.net/programs/oqab8dp4jl/signup',
    image: veteransDayClinic,
  },
  {
    title: 'Fall & Winter Skills Clinic',
    href: 'https://atlanticunitedsc.byga.net/programs/gf58kmsq81/signup',
    image: fallWinterSkillsClinic,
  },
  {
    title: '6 Week Series',
    href: 'https://atlanticunitedsc.byga.net/programs/ihc160c00q/signup',
    image: sixWeekSeries,
  },
  {
    title: 'Friday Night Lights',
    href: 'https://atlanticunitedsc.byga.net/programs/nizsvkrlwf/signup',
    image: fridayNightLights,
  }
];

export default function CampsAndClinics() {
  return (
    <Box sx={{ pb: { xs: 8, md: 12 }, color: '#e9eef6', bgcolor: 'background.default' }}>
      <Box
        sx={{
          pt: { xs: '120px', sm: '160px', md: '180px' },
          pb: { xs: '80px', md: '100px'},
          color: '#e9eef6',
          backgroundImage: `linear-gradient(120deg, rgba(0, 0, 49, 0.85) 0%, rgba(0, 0, 0, 0.3) 100%), url(${campsAndClinicsHeroImage})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <Stack spacing={3} maxWidth={880}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.3)',
                px: 2,
                py: 1,
                borderRadius: 2,
                width: 'fit-content',
              }}
            >
              <SportsSoccerIcon />
              <Typography variant="button" sx={{ letterSpacing: 1.2, fontWeight: 700 }}>
                Atlantic United • Camps & Clinics
              </Typography>
            </Box>
            <Typography variant="h2" component="h1" sx={{ fontSize: { xs: '34px', sm: '46px', lg: '62px' }, lineHeight: 1.05 }}>
              Build skills faster with our camps and clinics.
            </Typography>
            <Typography variant="h6" sx={{ maxWidth: 760, opacity: 0.95, lineHeight: 1.8 }}>
              From seasonal camps to weekly clinics, Atlantic United offers soccer training for all ages and ability levels. Our sessions focus on technical mastery, tactical awareness, and confidence on the field.
            </Typography>
            {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Button
                variant="contained"
                color="secondary"
                href="#campsAndClinics-highlights"
                sx={{ transition: 'opacity 0.3s, transform: 0.3s', '&:hover': { opacity: 0.85, transform: 'scale(1.05)' } }}
              >
                Learn More
              </Button>
              <Button
                variant="outlined"
                color="inherit"
                href="#campsAndClinics-contact"
                sx={{ transition: 'opacity 0.3s, transform 0.3s', '&:hover': { opacity: 0.85, transform: 'scale(1.05)' } }}
              >
                Contact Us
              </Button>
            </Stack> */}
          </Stack>
        </Container>
      </Box>

      <Container maxWidth="xl" disableGutters sx={{ px: { xs: 2, md: 4 } }}>
        <Box id="campsAndClinics-highlights" sx={{ mt: { xs: 6, md: 10 } }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 4, textAlign: 'center' }}>
            Current Camps & Clinics
          </Typography>
          <Grid container spacing={3} justifyContent="center">
            {campsAndClinicsCards.map((camp) => (
              <Grid item xs={12} sm={6} lg={4} key={camp.image}>
                <Card
                  sx={{
                    height: '100%',
                    bgcolor: '#0a111eff',
                    border: (t) => `1px solid ${t.palette.primary.main}22`,
                    boxShadow: '0 24px 70px rgba(255,255,255,0.08)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 28px 80px rgba(255,255,255,0.12)',
                    },
                  }}
                >
                  <Box
                    component="a"
                      href={camp.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Register for ${camp.title}`}
                      sx={{
                        position: 'relative',
                        display: 'block',
                        overflow: 'hidden',
                        '&:hover img, &:focus-visible img': { opacity: 0.45 },
                        '&:hover .register-overlay, &:focus-visible .register-overlay': { opacity: 1 },
                        '&:focus-visible': { outline: '3px solid', outlineColor: 'secondary.main', outlineOffset: 3 },
                      }}
                    >
                    <CardMedia
                      component="img"
                      image={camp.image}
                      alt={camp.title}
                      sx={{
                        height: 450,
                        objectFit: 'contain',
                        bgcolor: '#05090e',
                        transition: 'opacity 0.25s ease',
                      }}
                    />
                    <Box
                      className="register-overlay"
                      component="span"
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: 0,
                        transition: 'opacity 0.25s ease',
                        pointerEvents: 'none',
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          px: 3,
                          py: 1.25,
                          borderRadius: 1,
                          bgcolor: 'secondary.main',
                          color: 'secondary.contrastText',
                          fontWeight: 700,
                          letterSpacing: 1,
                        }}
                      >
                        REGISTER
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mt: { xs: 8, md: 12 } }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
            Features
          </Typography>
          <Typography variant="body1" sx={{ maxWidth: 840, opacity: 0.92, lineHeight: 1.8 }}>
            Our camps and clinics combine expert coaching with purposeful practice. Players leave each session with improved technique, better game understanding, and the confidence to perform under pressure.
          </Typography>

          <Grid container spacing={3} justifyContent="center" sx={{ mt: 3 }}>
            {[
              'Small group ratios for maximum touches',
              'Age-specific sessions for better player development',
              'Technical and tactical focus with game-like training',
              'Experienced coaches committed to player growth',
            ].map((benefit) => (
              <Grid item xs={12} md={6} key={benefit}>
                <Paper
                  elevation={8}
                  sx={{
                    width: '100%',
                    maxWidth: 350,
                    p: 3,
                    bgcolor: 'rgba(13, 71, 161, 0.08)',
                    border: (t) => `1px solid ${t.palette.primary.main}22`,
                    boxShadow: '0 18px 45px rgba(255,255,255,0.08)',
                    backdropFilter: 'blur(6px)',
                    minHeight: 130,
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                  }}
                >
                  <Stack spacing={1.5} alignItems="flex-start">
                    <Typography variant="body1" sx={{ color: '#d7ecff', fontWeight: 500 }}>
                      {benefit}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
